import { TicketStatus } from './models';

/** Statuses an agent may move to `resolved`: the agent rows of
 *  bluetitan-support/core/status_machine.py _ALLOWED_TRANSITIONS. The server is the
 *  authority (it re-checks and 409s); the console uses this only to decide which
 *  Resolve controls are live. */
export const RESOLVABLE_STATUSES: ReadonlySet<TicketStatus> = new Set<TicketStatus>(['new', 'active', 'pending']);

export function isResolvable(status: TicketStatus | '' | null | undefined): boolean {
  return !!status && RESOLVABLE_STATUSES.has(status);
}

/** The inbox's default status filter: `open` is a server-side alias for
 *  new + active + pending (repositories/tickets.py list_queue_tickets). */
export const DEFAULT_INBOX_STATUS = 'open' as const;
